<template>
  <div class="selector">
    <div class="header">
      <div class="title">选择图层</div>
    </div>

    <div class="item" v-for="(item, index) in list" :key="item" :class="activeIndex === index ? 'active' : ''" @click="$emit('change', index)">
        <span class="menu-icon">⚙️</span>
        <span style="margin-left: 0.5rem">{{ item }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      list: ["数据中心", "历史管网分析"],
    };
  },
};
</script>


<style lang="less" scoped>
.selector {
  position: fixed;
  top: 11vh;
  left: 1vw;
  z-index: 99;
  background-color: var(--default-bgcolor);
  width: 15vw;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  padding: 1rem;
  border: 1px solid #065645;
  color: #adadad;
  & > .header {
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 1.1rem;
    color: #00ff96;
  }

  .item {
    display: flex;
    align-items: center;
    padding: 1rem 0.7rem;
    cursor: pointer;
    margin:1rem 0;
    &:last-child {
      border-bottom-width: 0;
    }
  }

  .active {
    background: rgba(0, 255, 150, 0.2);
    color: #00ff96;
    border-left: 3px solid #00ff96;
    border-radius:10px ;
  }
}
</style>
